module.exports = __webpack_public_path__ + "img/browse-vehicles-search-hero.10ced21a.gif";